import angular from 'angular';
import * as R from 'ramda';
import BaseController from './bcp.base.controller';

export default function BCPController(
  $filter,
  $location,
  $q,
  $rootScope,
  $scope,
  addAssessmentDialog,
  alerts,
  orgDataService,
  bcpDataService,
  bcpSharedModelService,
  vmDataService,
  loaderService,
  serviceIds,
  bcpSettingsDialog,
  ssDialogService,
  userService,
) {
  BaseController.call(this, userService, loaderService);
  this.initPermissions();
  const vm = this;

  vm.groupId = 13;
  vm.eulaAccepted = true;
  vm.appIsLoaded = false;

  vm.loaderService = loaderService;

  vm.handleShowSettings = handleShowSettings;
  vm.handleShowAddAssessment = handleShowAddAssessment;

  _activate();

  /** **************************************************
   * Event Handlers
   */

  function handleShowSettings($event) {
    loaderService.showViewLoader = true;
    const promises = [
      bcpDataService.getSettings(),
      orgDataService.getSelectableUsers(),
      vmDataService.getVendorsByCustomer(vm.customerId),
    ];

    return $q.all(promises).then(response => {
      ssDialogService.dialogs.bcp.settingsDialog = ssDialogService.alert(
        bcpSettingsDialog.getOptions($event, {
          settings: response[0].data.result,
          users: response[1].data.result,
          vendors: response[2].data.result,
        }),
      );
      loaderService.showViewLoader = false;
      return ssDialogService.show(ssDialogService.dialogs.bcp.settingsDialog);
    });
  }

  function handleShowAddAssessment($event) {
    return bcpSharedModelService.allowNewAssessment().then(isAllowed => {
      if (!isAllowed) {
        alerts.warning('Only one active Plan is allowed.');
      } else {
        $q.all([bcpDataService.getSettings(), bcpDataService.getAssessment(0)]).then(
          getSettingsAndAssessmentResponse => {
            // Display new assessment dialog
            ssDialogService.dialogs.bcp.addAssessmentDialog = ssDialogService.alert(
              addAssessmentDialog.getOptions($event, {
                assessment: getSettingsAndAssessmentResponse[1].data,
                settings: getSettingsAndAssessmentResponse[0].data.result.customerConfiguration,
              }),
            );
            return ssDialogService.show(ssDialogService.dialogs.bcp.addAssessmentDialog);
          },
        );
      }
    });
  }

  /** **************************************************
   * Private Functions
   */

  function _activate() {
    _initEventListeners();
    return _initPage().then(() => {
      vm.appIsLoaded = true;
      loaderService.showViewLoader = false;
      vm.eulaAccepted = true;
    });
  }
  /*
  function _verifyServiceAcceptance() {
    return $q.all([
      orgDataService.getCSAText(serviceIds.BCP),
      userService.getUser()
    ]).then((results) => {
      const eula = results[0].data.result[0];
      const user = results[1];
      return orgDataService.getEULAServiceAcceptanceByCustomer(user.customerId, eula.serviceEulaId)
        .then((acceptanceResponse) => {
          const requiresServiceAcceptance = !!eula;
          const hasServiceAcceptance = (acceptanceResponse.data.recordCount > 0);

          if (!hasServiceAcceptance && requiresServiceAcceptance) {
            return _showCustomerServiceAcceptance();
          }

          vm.eulaAccepted = true;
          return _initPage();
        });
    });
  }
  */
  function _initPage() {
    return $q
      .all([
        bcpDataService.initApp(),
        orgDataService.getIsNavantaUser(),
        //bcpDataService.getEcosystemNavigations(114),
      ])
      .then(response => {
        //console.log(response);
        vm.customerId = response[0].data.customerId;
        $rootScope.backupFrequencyOptions = response[0].data.backupFrequencyOptions;
        $rootScope.threatTypes = response[0].data.threatTypes;
        $rootScope.threatCategories = response[0].data.threatCategories;
        _filterThreatCategories($rootScope.threatCategories);
        $rootScope.testTypes = response[0].data.testTypes;
        vm.assessments = response[0].data.assessments;
        vm.rmmReportingSource = response[0].data.rmmReportingSource;
        vm.isNavantaUser = response[1].data.result;

        vm.incompleteAssessments = $filter('filter')(vm.assessments, { approvalDate: null });
        vm.hasIncompleteAssessments = vm.incompleteAssessments.length > 0;

        vm.completedAssessments = $filter('filter')(vm.assessments, { approvalDate: '' });
        vm.hasCompletedAssessments = vm.completedAssessments.length > 0;

        $rootScope.latestCompletedAssessment = $filter('orderBy')(vm.completedAssessments, 'approvalDate', true)[0];
      });

    // return $q.all([
    //   _refreshAssessments(),
    //   _populateBackupFrequencyDDL(),
    //   _populateThreatsCategoryDDLs(),
    //   _populateTestTypes(),
    // ]);
  }
  /*
  function _respondToCancelCustomerServiceAcceptance() {
    alerts.warning('In order to use BCP Blueprint, EULA acceptance is required.');
    $location.path('/');
  }

  function _showCustomerServiceAcceptance() {
    customerServiceAcceptanceDialog.show(
      serviceIds.BCP,
      _customerAcceptedServiceAgreement,
      _respondToCancelCustomerServiceAcceptance
    );
  }

  function _customerAcceptedServiceAgreement() {
    loaderService.showViewLoader = true;
    return _verifyServiceAcceptance().then(() => {
      loaderService.showViewLoader = false;
      vm.appIsLoaded = true;
    });
  }
  */
  function _initEventListeners() {
    $scope.$on('refreshBCPAssessments', _refreshAssessments);
    $scope.$on('refreshStatuses', _refreshStatuses);
  }

  function _refreshAssessments() {
    loaderService.showViewLoader = true;
    return bcpDataService.getAssessments().then(response => {
      vm.assessments = response.data.result;

      vm.incompleteAssessments = $filter('filter')(vm.assessments, { approvalDate: null });
      vm.hasIncompleteAssessments = vm.incompleteAssessments.length > 0;

      vm.completedAssessments = $filter('filter')(vm.assessments, { approvalDate: '' });
      vm.hasCompletedAssessments = vm.completedAssessments.length > 0;

      $rootScope.latestCompletedAssessment = $filter('orderBy')(vm.completedAssessments, 'approvalDate', true)[0];

      loaderService.showViewLoader = false;
    });
  }

  function _refreshStatuses() {
    const incompleteAssessment = R.find(R.propEq('approvalDate', null), vm.assessments);

    return bcpDataService.getAssessmentStatus(incompleteAssessment.assessmentId).then(getAssessmentStatusResponse => {
      incompleteAssessment.status = getAssessmentStatusResponse.data;
      $rootScope.$broadcast('refreshStatusesComplete', incompleteAssessment.status);
    });
  }

  // function _populateBackupFrequencyDDL() {
  //   return bcpDataService.getBackupFrequencyOptions()
  //     .then((getBackupFrequencyOptionsResponse) => {
  //       $rootScope.backupFrequencyOptions = getBackupFrequencyOptionsResponse.data.result;
  //     });
  // }

  // function _populateThreatsCategoryDDLs() {
  //   return bcpDataService.getThreatTypes()
  //     .then((getThreatTypesResponse) => {
  //       $rootScope.threatTypes = getThreatTypesResponse.data.result;
  //       return bcpDataService.getThreatCategories()
  //         .then((getThreatCategoriesResponse) => {
  //           $rootScope.threatCategories = getThreatCategoriesResponse.data.result;
  //           _filterThreatCategories($rootScope.threatCategories);
  //         });
  //     });
  // }

  function _filterThreatCategories(threatCategories) {
    angular.forEach(threatCategories, category => {
      category.threatTypes = $filter('filter')(
        $rootScope.threatTypes,
        { threatCategoryId: category.threatCategoryId },
        true,
      );
    });
  }

  // function _populateTestTypes() {
  //   return bcpDataService.getTestTypes().then((response) => {
  //     $rootScope.testTypes = response.data.result;
  //   });
  // }
}

BCPController.$inject = [
  '$filter',
  '$location',
  '$q',
  '$rootScope',
  '$scope',
  'addAssessmentDialog',
  'alerts',
  'orgDataService',
  'bcpDataService',
  'bcpSharedModelService',
  'vmDataService',
  'loaderService',
  'serviceIds',
  'bcpSettingsDialog',
  'ssDialogService',
  'userService',
];
